// project imports
import { getVisualDepth } from '../visualDepth';

// ==============================|| OVERRIDES - TABLE CONTAINER ||============================== //

export default function TableContainer(theme) {
  const vd = getVisualDepth(theme);

  return {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          ...(vd.tableLift && {
            boxShadow: vd.tableContainerShadow,
            border: vd.tableContainerBorder
          })
        }
      }
    }
  };
}
